import { useQuery } from "@tanstack/react-query";
import { partnerReservationsRepo } from "@/data/repos/partnerReservationsRepo";
import { reservationsQueryKey } from "@/features/reservations/hooks/useReservationAnswers";

/** The same query key the queue reads, so an answer given in one place shows up
 *  in the other without a reload. */
export function useReservationList() {
  const query = useQuery({
    queryKey: reservationsQueryKey,
    queryFn: () => partnerReservationsRepo.list(),
  });

  return {
    reservations: query.data ?? [],
    hasLoaded: query.isSuccess,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
